import { render, staticRenderFns } from "./ReviewsManage.vue?vue&type=template&id=04906347"
import script from "./ReviewsManage.vue?vue&type=script&lang=js"
export * from "./ReviewsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports